import { createEffect } from 'effector';

import { apiFetch } from '@m/utils/http';

import type { WhitelistedEmailForm } from '@m/types/api';

export const getWhitelistedEmails = createEffect({
  handler: ({ subscriptionPlanId }: { subscriptionPlanId: number }) =>
    apiFetch(`/admin/subscription/plan/${subscriptionPlanId}/whitelisted-emails`),
});

export const addWhitelistedEmails = createEffect({
  handler: ({
    subscriptionPlanId,
    whitelistedEmailForm,
  }: {
    subscriptionPlanId: number;
    whitelistedEmailForm: WhitelistedEmailForm;
  }) =>
    apiFetch(`/admin/subscription/plan/${subscriptionPlanId}/whitelisted-emails`, {
      method: 'POST',
      body: whitelistedEmailForm,
    }),
});

export const deleteWhitelistedEmail = createEffect({
  handler: ({
    whitelistedEmailId,
    subscriptionPlanId,
  }: {
    subscriptionPlanId: number;
    whitelistedEmailId: number;
  }) =>
    apiFetch(
      `/admin/subscription/plan/${subscriptionPlanId}/whitelisted-email/${whitelistedEmailId}`,
      {
        method: 'DELETE',
      },
    ),
});

export const deleteWhitelistedEmailByEmail = createEffect({
  handler: ({
    whitelistedEmail,
    subscriptionPlanId,
  }: {
    subscriptionPlanId: number;
    whitelistedEmail: string;
  }) =>
    apiFetch(
      `/v2/admin/subscription/plan/${subscriptionPlanId}/whitelisted-email/${whitelistedEmail}`,
      {
        method: 'DELETE',
      },
    ),
});
